export default __webpack_public_path__ + "static/media/FelixBinder.4c6026d0.png";